import { IonRangeSliderComponent }   from './ion-range-slider.component';
import {NgModule} from "@angular/core";

@NgModule({
    exports: [IonRangeSliderComponent],
    declarations: [IonRangeSliderComponent]
})
export class IonRangeSliderModule { }